import React, { useEffect, useState } from 'react'
import * as _ from 'lodash'
import { connect } from 'react-redux'
import { DocumentIcon } from '../utils/icons';
import './FormBudgetPage.scss'
import Separator from '../components/Separator';
import { tokerUser } from '../hooks/user';
import { resetBudget, showPopup, showSpinner } from '../actions'
import { useNavigate } from "react-router-dom";
import { PopupOneButton } from '../components/PopupOneButton'
import { useActiveDesactiveSrollBody } from '../hooks/activeDesactivScrollBody';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { scrollBodyTop } from '../hooks/scrollPosition';
import { comprobarDatos } from '../hooks/validateForm';
import { sendBudget } from '../hooks/budget';
import { getProducts } from '../hooks/gets';

const FormBudgetPage = (props) => {
    const navigate = useNavigate();
    const { userActive, zones } = props
    const [sentBudget, setSentBudget] = useState(false)
    const [userBudget, setUserBudget] = useState({
        cif: '',
        empresa: '',
        name: '',
        email: '',
        role: '',
        phonenumber: '',
        zone: '',
        location: '',
        comments: ''
    })

    const reglas = {
        cif: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
        },
        empresa: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
        },
        location: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
        },
        name: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
        },
        phonenumber: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
            format: { pattern: '[0-9]+', message: 'solo puede contener digitos del 0 al 9' },
        },
        email: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
            email: { message: 'con un formato invalido' },
        },
        zone: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
        },
    };

    useEffect(() => {
        scrollBodyTop()
        if (_.isEmpty(props.budget)) {
            navigate(-1);
        }
    }, [])

    useEffect(() => {
        if (!_.isEmpty(userActive)) {
            setUserBudget({
                cif: userActive.cif,
                empresa: userActive.empresa,
                name: userActive.name,
                email: userActive.email,
                role: userActive.role,
                phonenumber: userActive.phonenumber,
                zone: userActive.zone,
                location: '',
                comments: ''
            })
        } else {
            setUserBudget({
                cif: '',
                empresa: '',
                name: '',
                email: '',
                role: '',
                phonenumber: '',
                zone: '',
                location: '',
                comments: ''
            })

        }
    }, [userActive])

    const handleChange = (event) => {
        const { name, value } = event.target;
        setUserBudget(() => ({
            ...userBudget,
            [name]: value
        }))
    }

    const handleClickSend = () => {
        const alias = {
            name: 'nombre',
            phonenumber: 'teléfono',
            zone: 'zona',
            location: 'localidad',
            comments: 'observaciones'
        }

        comprobarDatos(userBudget, reglas, alias).then(res => {
            props.showSpinner(true)
            useActiveDesactiveSrollBody(true)
            getProducts().then(resProducts => {
                tokerUser().then(res => {
                    const tokenUser = res
                    const data = {
                        tokenUser: tokenUser,
                        budget: props.budget,
                        allProducts: resProducts,
                        userBudget: userBudget
                    }
                    sendBudget(data).then(res => {
                        setSentBudget(true)
                        props.showSpinner(false)
                        props.resetBudget()
                    }).catch(err => {
                        props.showSpinner(false)
                        useActiveDesactiveSrollBody(false)
                        props.showPopup({ active: true, message: 'Error al enviar el presupuesto', type: 'error' })
                    })
                })
            }).catch(err => {
                props.showSpinner(false)
            })
        }).catch(err => {
            props.showSpinner(false)
            props.showPopup({ active: true, message: err, type: 'error' })
        })
    }

    const handleClickEnd = () => {
        setSentBudget(false)
        useActiveDesactiveSrollBody(false)
        navigate('/');
    }

    return (
        <div className="form-budget-page-container">
            {sentBudget &&
                <PopupOneButton title="¡Has finalizado tu solicitud con éxito!" text="Pronto recibirás vía mail tu presupuesto." textButton="Terminar" onClick={handleClickEnd} />
            }
            <div className="header">
                <p>Finalizar solicitud</p>
                <DocumentIcon size={40} />
            </div>
            <div className="separator">
                <Separator />
            </div>
            <div className="form">
                {_.isEmpty(userActive) &&
                    <div className="input-block">
                        <label htmlFor="cif">CIF:</label>
                        <div className="input">
                            <input type="text" name="cif" value={userBudget.cif} onChange={handleChange} />
                        </div>
                    </div>
                }
                <div className="input-block">
                    <label htmlFor="empresa">Empresa:</label>
                    <div className="input">
                        <input type="text" name="empresa" value={userBudget.empresa} onChange={handleChange} />
                    </div>
                </div>
                <div className="input-block">
                    <label htmlFor="location">Centro / localidad:</label>
                    <div className="input">
                        <input type="text" name="location" value={userBudget.location} onChange={handleChange} />
                    </div>
                </div>
                {_.isEmpty(userActive) &&
                    <div>
                        <div className="input-block">
                            <label htmlFor="name">Nombre y apellido:</label>
                            <div className="input">
                                <input type="text" name="name" value={userBudget.name} onChange={handleChange} />
                            </div>
                        </div>
                        <div className="input-block">
                            <label htmlFor="phonenumber">Teléfono:</label>
                            <div className="input">
                                <input type="text" name="phonenumber" value={userBudget.phonenumber} onChange={handleChange} />
                            </div>
                        </div>
                        <div className="input-block">
                            <label htmlFor="email">Email:</label>
                            <div className="input">
                                <input type="text" name="email" value={userBudget.email} onChange={handleChange} />
                            </div>
                        </div>
                        <div className="input-block select">
                            <label htmlFor="zone">Zona:</label>
                            <Select
                                MenuProps={{
                                    anchorOrigin: {
                                        vertical: "bottom",
                                        horizontal: "left"
                                    },
                                    transformOrigin: {
                                        vertical: "top",
                                        horizontal: "left"
                                    },
                                    getContentAnchorEl: null
                                }}
                                name="zone"
                                IconComponent={ArrowForwardIosIcon}
                                value={userBudget.zone}
                                id="select"
                                onChange={handleChange}>
                                <MenuItem value="">Elija una opción</MenuItem>
                                {zones.region.map((zone, index) => {
                                    return (
                                        <MenuItem className={zones.region.length - 1 === index ? "regions-end" : ""} value={zone.Name} key={index}>{zone.Name}</MenuItem>
                                    )
                                })}
                                {zones.country.map((zone, index) => {
                                    return (
                                        <MenuItem value={zone.Name} key={index}>{zone.Name}</MenuItem>
                                    )
                                })}
                            </Select>
                        </div>

                    </div>
                }
                <div className="input-block">
                    <label htmlFor="comments">Observaciones:</label>
                    <div className="input">
                        <textarea id="comment" cols="30" rows="5" name="comments" value={userBudget.comments} onChange={handleChange} placeholder="Cuéntanos algún detalle que debamos saber"></textarea>
                    </div>
                </div>
            </div>
            <div className="boton">
                <button className="btn" onClick={handleClickSend}>ENVIAR</button>
            </div>
        </div>
    )
}

const mapDispatchToProps = {
    resetBudget,
    showPopup,
    showSpinner
}

const mapStateToProps = state => state

export default connect(mapStateToProps, mapDispatchToProps)(FormBudgetPage)
